<section
  class="home-stats"
  data-section-id="homeia_component_stats"
  *ngIf="!loading && !error && !empty && metrics?.length; else statsState"
>
  <div class="stats-heading">
    <h2>{{ lang.translate('home.stats.title') }}</h2>
    <p>{{ lang.translate('home.stats.description') }}</p>
    <p class="section-note">{{ lang.translate('home.stats.note') }}</p>
  </div>

  <div class="stats-grid" data-section-id="homeia_component_stats_grid" role="list">
    <article
      class="stat-card"
      *ngFor="let metric of metrics; let idx = index"
      role="listitem"
      [attr.data-trend]="metric.trend || 'steady'"
      [attr.data-section-id]="'homeia_component_stats_card_' + idx"
    >
      <p class="stat-label">{{ getMetricLabel(metric) }}</p>
      <p class="stat-value" aria-live="polite">{{ metric.value }}</p>
      <p class="stat-helper">{{ metric.helperText }}</p>
      <div class="stat-trend" *ngIf="metric.trendLabel">
        <i class="fas" [ngClass]="{
            'fa-arrow-up': metric.trend === 'up',
            'fa-arrow-down': metric.trend === 'down',
            'fa-minus': metric.trend === 'steady'
          }" aria-hidden="true"></i>
        <span>{{ metric.trendLabel }}</span>
      </div>
    </article>
  </div>
</section>

<ng-template #statsState>
  <div class="error-state" *ngIf="error; else statsNonError">
    <p class="error-title">{{ error.title }}</p>
    <p class="error-message">{{ error.message }}</p>
    <div class="error-actions">
      <button type="button" class="btn btn-outline-primary" (click)="onRetry()">
        {{ lang.translate('home.general.retry') }}
      </button>
      <span class="retry-after" *ngIf="error.retryAfterSeconds">
        {{ lang.translate('home.general.retryAfter') }} {{ error.retryAfterSeconds }}s
      </span>
    </div>
  </div>
  <ng-template #statsNonError>
    <div class="empty-state" *ngIf="empty; else statsLoading">
      {{ lang.translate('home.stats.empty') }}
    </div>
    <ng-template #statsLoading>
      <div class="home-stats loading" role="status">{{ lang.translate('home.general.loading') }}</div>
    </ng-template>
  </ng-template>
</ng-template>
